import React from "react";

const StepsToYourNextJob = () => {
  return (
    <div className="w-full min-h-screen bg-blue-900 text-white flex items-center justify-center p-6">
      <div className="w-full max-w-6xl flex flex-wrap lg:flex-nowrap">
        {/* Left Section: Title and Button */}
        <div className="w-full lg:w-1/3 space-y-6 flex flex-col justify-center items-start">
          <h1 className="text-5xl py-15 font-semibold leading-snug">
            5 steps to <br /> your next job
          </h1>
          <button className="bg-white text-blue-900 px-6 py-3  rounded hover:bg-gray-200 transition duration-300 font-medium">
            More tips and guidance
          </button>
        </div>

        {/* Right Section: Steps */}
        <div className="w-full lg:w-2/3 mt-8 lg:mt-0 space-y-4">
          {[
            {
              number: "01",
              title: "Find your ideal job",
              description: "Visit our job board and browse exciting opportunities.",
            },
            {
              number: "02",
              title: "Send your application online",
              description: "Along with your updated resume and cover letter.",
            },
            {
              number: "03",
              title: "Application screening",
              description: "We'll get back to you as soon as possible.",
            },
            {
              number: "04",
              title: "Participate in interview(s)",
              description:
                "Time to meet your future manager and ask all your questions.",
            },
            {
              number: "05",
              title: "Employment offer",
              description:
                "Congratulations! We have made our final decision.",
            },
          ].map((step, index) => (
            <div
              key={index}
              className="bg-blue-800 rounded-lg p-4 flex items-start space-x-4"
            >
              <span className="text-3xl font-bold text-white">{step.number}</span>
              <div>
                <h3 className="text-lg font-semibold">{step.title}</h3>
                <p className="text-gray-300">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default StepsToYourNextJob;
